import {
  DepositWithdrawCollaterals,
  IsUSDC,
} from "../../../constants/addresses";
import { ChainIdEnum } from "../../../enums/chain";
import { getAssetShortName } from "../../../utils/asset/assets";

const normalizeAssetValue = (value?: string) =>
  value?.trim().toLowerCase().replace(/[\s_-]/g, "") || "";

export const getCollateralAssetValues = (
  collateralAsset: any,
  chainId: ChainIdEnum
) => {
  const rawValues =
    typeof collateralAsset === "string"
      ? [collateralAsset]
      : [
          collateralAsset?.asset_id,
          collateralAsset?.asset_name,
          getAssetShortName(collateralAsset?.asset_id, chainId),
          getAssetShortName(collateralAsset?.asset_name, chainId),
        ];

  return rawValues
    .filter(Boolean)
    .map((value) => normalizeAssetValue(String(value)));
};

export const getSelectedAssetValues = (
  asset: DepositWithdrawCollaterals,
  chainId: ChainIdEnum
) =>
  [
    asset,
    getAssetShortName(asset, chainId),
    IsUSDC(asset) ? DepositWithdrawCollaterals.Usdc : undefined,
  ]
    .filter(Boolean)
    .map((value) => normalizeAssetValue(String(value)));
